import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import reportWebVitals from "./reportWebVitals";
import envFile from "./envFile";

ReactDOM.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={envFile.reCaptchaKey}>
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
